<template>
	<div>

		<div v-if="!org.subscription.subscribed" class="raised-box-lifted c-bg-alert t-invert p-box s-around">
			<p style="font-size:1.3em;font-weight:bold">
				<i class="fa fa-exclamation-triangle btn_icon"></i>{{ dsplApostrophize(org.name) }} trial {{ expiredExpires(org.subscription.trial_ends_at) }} {{ timeToExpiry(org.subscription.trial_ends_at) }}</p>
			<p>To keep being able to create templates and generate configs in {{ dsplApostrophize(org.name) }} account, add your card details now.</p>
			<p><button @click="Event.$emit('activate-org',org)" class="btn-white" >Add card details now</button></p>
		</div>

		<div class="cols cl-spaced-more">
			<div class="cl">
				<div class="raised-box p-box">
					<h2>
						<span v-if="!users_loaded" class="loading_string"></span>
						<template v-else >
							{{ user_list.length}} Active users
						</template>
					</h2>

					<List
						class="flat-box"
						:loading="!users_loaded"
						:results="user_list"
						:noHeading="true"
						:columns="[
							{
								usericon:1,
							},
							{
								label:'Name',
								name:'name',
							},
							{
								label:'Email',
								name:'email',
							},
						]"
					/>

					<p>
						<router-link :to="{name:'org.team',params:{org_id:org.id}}" class="btn-a" >Add/remove team members</router-link>
					</p>

				</div>
			</div>
			<div class="cl">
				<div class="raised-box p-box">
					
					<h2>Your subscription</h2>
					<template v-if="org.subscription.subscribed" >
						<p class="flat-box p-box-less" ><i class="fa fa-check c-active btn_icon"></i>{{ dsplApostrophize(org.name) }} subscription is active.</p>
					</template>
					<template v-else >
						<div class="flat-box p-box t-center">
							<p><i>No subscription set up yet!</i></p>
							<p><button @click="Event.$emit('activate-org',org)" class="btn-alert" >Add card details now</button></p>
						</div>
					</template>

					<p>
						<router-link :to="{name:'org.billing',params:{org_id:org.id}}" class="btn-outline" >Billing settings</router-link>
					</p>

				</div>
			</div>
		</div>

	</div>
</template>

<script>

	import List from '../../components/List';
	export default {
		props : ['org'],
		components: {List},
		data(){
			return {
				Event,
				users : [],
				users_loaded : false,
			};
		},
		mounted(){
			this.refreshUsers();
		},
		computed:{
			user_list(){
				return this.users.map(x=>{
					x.name = [x.first_name,x.last_name].join(' ')
					return x;
				})
			}
		},
		methods : {
			expiredExpires(mysql_string){
				var d = moment.utc(mysql_string);
				var diff = moment().diff(d);
				return diff>0 ? 'expired' : 'expires';
			},
			
			refreshUsers(){
				var self = this;
				if(!this.org) return;

				return api.call('get','/orgs/'+this.org.id+'/users')
					.then((result)=>{ 
						self.users = result.data;
						self.users_loaded = true;
					});

			},

			timeToExpiry(mysql_string){
				var d = moment.utc(mysql_string);
				var diff = moment().diff(d);
				var since = moment.duration(diff);
				
				return  d.fromNow();
			}
		},
	}

</script>